// emailSubscriptionService.js
import { getFunctions, httpsCallable } from 'firebase/functions';

class EmailSubscriptionService {
  constructor() {
    this.functions = getFunctions();
  }

  async subscribe(email) {
    try {
      const subscribeEmail = httpsCallable(this.functions, 'subscribeEmail');
      const result = await subscribeEmail({ email });
      
      return result.data;
    } catch (error) {
      console.error('Error subscribing:', error);
      throw error;
    }
  }
}

export default new EmailSubscriptionService();